import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import OperatorHeader from '../ui-component/header/OperatorHeader';

// Support pages
const SupportIncidentsPage = Loadable(lazy(() => import('views/pages/support/SupportIncidentsPage')));
const IncidentDetailPage = Loadable(lazy(() => import('views/pages/support/IncidentDetailPage')));
const PanelSupport = Loadable(lazy(() => import('views/pages/panel/PanelSupport')));

const Profile = Loadable(lazy(() => import('views/pages/users/profile/Profile')));

// ==============================|| SUPPORT ROUTING ||============================== //

const SupportRoutes = {
    path: '/',
    element: <OperatorHeader />,
    children: [
        {
            path: '/',
            element: <PanelSupport />
        },
        {
            path: '/profile',
            element: <Profile />
        },
        {
            path: '/support',
            children: [
                {
                    path: '',
                    element: <SupportIncidentsPage />
                },
                {
                    path: 'incident/:id',
                    element: <IncidentDetailPage />
                }
            ]
        },
        {
            path: '*',
            element: <PanelSupport />
        }
    ]
};

export default SupportRoutes;
